module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("faq_main", [["div",{"class":"faqs"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/templates/sitepage/faq/main.tpl
// module id = 69
// module chunks = 5